(function () {
  'use strict';

  angular
    .module('dashboard.project.overview')
    .controller('reportDataRowCtrl', reportDataRowCtrl);

  reportDataRowCtrl.$inject = ['$scope', '$translate'];

  function reportDataRowCtrl($scope, $translate) {
    var vm = this;

    $scope.getTypeName = function (entity, isSection) {
      var typeName = '';

      switch (entity.type) {
        case '2':
          typeName =
            entity.room +
            '-' +
            $translate.instant('reports.page.byprojects.type.room') +
            ' ' +
            $translate.instant('reports.page.byprojects.type.apartments');
          break;
        case '3':
          typeName = $translate.instant(
            'reports.page.byprojects.type.commerce',
          );
          break;
        case '4':
          typeName =
            entity.room +
            '-' +
            $translate.instant('reports.page.byprojects.type.room') +
            ' ' +
            $translate.instant('reports.page.byprojects.type.villas');
          break;
        case '5':
          typeName = $translate.instant(
            'reports.page.byprojects.type.land.plots',
          );
          break;
        case '6':
          typeName =
            entity.room +
            '-' +
            $translate.instant('reports.page.byprojects.type.room') +
            ' ' +
            $translate.instant('reports.page.byprojects.type.townhouses');
          break;
        case '7':
          typeName = $translate.instant(
            'reports.page.byprojects.type.hotel.type',
          );
          break;
        case '8':
          typeName = $translate.instant(
            'reports.page.byprojects.type.store.rooms',
          );
          break;
        case '9':
          typeName =
            entity.room +
            '-' +
            $translate.instant('reports.page.byprojects.type.room') +
            ' ' +
            $translate.instant('reports.page.byprojects.type.attics');
          break;
        case '10':
          typeName = $translate.instant(
            'reports.page.byprojects.type.parking.lots',
          );
          break;
        case '11':
          typeName = $translate.instant(
            'reports.page.byprojects.type.pavement.parkings',
          );
          break;
        case '12':
          typeName =
            entity.room +
            '-' +
            $translate.instant('reports.page.byprojects.type.room') +
            ' ' +
            $translate.instant('reports.page.byprojects.type.duplexes');
          break;
        case '13':
          typeName =
            entity.room +
            '-' +
            $translate.instant('reports.page.byprojects.type.room') +
            ' ' +
            $translate.instant('reports.page.byprojects.type.cottages');
          break;
        default: {
          typeName = isSection
            ? entity.section_name
            : $translate.instant('reports.page.byprojects.total');
        }
      }

      return typeName;
    };

    $scope.getFullPaymentPercent = function (entity) {
      if (entity.deals) {
        return Math.round(
          (parseInt(entity.count_deals_full_payment) / parseInt(entity.deals)) *
            100,
        );
      }
      return null;
    };
  }
})();
